export default function TestimonialSection() {
  return (
    <section className="relative w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <div className="flex flex-col lg:flex-row gap-0 rounded-3xl overflow-hidden bg-background-100">
          <div className="flex-1 flex flex-col justify-center p-10 md:p-14 lg:p-16">
            <span className="inline-flex items-center gap-1.5 text-sm text-foreground-500 font-medium mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-foreground-900"></span>
              Kundenstimmen
            </span>
            <blockquote className="text-2xl md:text-3xl lg:text-4xl font-serif italic text-foreground-900 mb-8 leading-relaxed">
              „OOPBUY Spreadsheet hat mein Shopping komplett verändert. Die Guides sind unglaublich detailliert und die Kategorie-Übersicht spart mir Stunden an Recherche."
            </blockquote>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center">
                <span className="text-sm font-semibold text-secondary-700">AK</span>
              </div>
              <div>
                <div className="text-sm font-semibold text-foreground-800">Alexander K.</div>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  Berlin, Deutschland
                  <span className="flex items-center gap-1 text-accent-600">
                    <i className="ri-shield-check-line text-xs"></i>
                    Verifiziert
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="lg:w-[40%] h-[300px] lg:h-auto bg-cover bg-center"
            style={{
              backgroundImage: 'url(https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20young%20European%20man%20in%20cream%20knit%20sweater%20looking%20away%20thoughtfully%20against%20warm%20beige%20textured%20wall%20soft%20natural%20lighting%20gentle%20expression%20lifestyle%20fashion%20portrait%20minimal%20composition%20sophisticated%20aesthetic&width=600&height=800&seq=testimonial-2026&orientation=portrait)',
            }}
          />
        </div>
      </div>
    </section>
  );
}